import { useNotificationModal } from '@room-match/shared-ui-components';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { AgencyPermissionEnums } from 'shared/enums/AgencyPermissionEnums';
import { RepresentationTypeEnum } from 'shared/enums/RepresentationTypeEnum';
import { representativeService } from 'shared/services/representativesService';

const { getSingleRepresentativeProfile } = representativeService();

export const useEditProfileData = () => {
  const { handleOpen, handleSetMessage, NotificationModal, isOpen } = useNotificationModal({
    type: 'warning',
  });
  const { id } = useParams() as { id: string };
  const { data, isLoading, isError, refetch, isFetching } = getSingleRepresentativeProfile(id);
  const use_global_permission =
    // If use own permission is false
    !data?.data?.profile?.use_own_talent_permissions ||
    // if the individual talent permission is null or undefined
    data?.data?.profile?.talent_permissions === null ||
    data?.data?.profile?.talent_permissions === undefined ||
    // If no division means, talent is a non division type
    data?.data?.profile?.division === null ||
    data?.data?.profile?.division === undefined;

  // Permission
  const permissions: AgencyPermissionEnums[] = useMemo(
    () =>
      (use_global_permission
        ? data?.data?.profile?.agency?.talent_permissions
        : data?.data?.profile?.talent_permissions) || [],
    [data],
  );

  const handleAction = useCallback(
    (value: AgencyPermissionEnums, callback: VoidFunction) => {
      if (
        data?.data?.profile?.representation_type === RepresentationTypeEnum.NON_REPRESENTED ||
        permissions.includes(value)
      ) {
        callback();
      } else {
        const msg = `You are not allowed to modify your ${value}. Only your representative on this profile can update this information. Please contact your representative.`;
        handleOpen();
        handleSetMessage('Permssion no granted', msg, 'Close');
      }
    },
    [data?.data?.profile],
  );

  return { data, permissions, isLoading, isFetching, isError, handleAction, refetch, NotificationModal, isOpen };
};
